const dev = {
  'api': 'https://ihtest.gooeto.com/API/',
  'ihAPI': '/API',
  'goodsAPI': 'https://yaotest.gooeto.com/goodsAPI/',
  'mallAPI': 'https://yaotest.gooeto.com/mallAPI/',
};
const pro = {
  'api': 'https://m.gooeto.com.cn/mAPI/',
  'ihAPI': '/API',
  'goodsAPI': 'https://yao.gooeto.com/goodsAPI/',
  'mallAPI': 'https://yao.gooeto.com/mallAPI/',
};
var config = process.env.NODE_ENV !== 'production' ? dev : pro;

let gooeto = '';
if (process.env.VUE_ENV === 'server') {
  gooeto = process.env.host;
} else {
  gooeto = location.origin;
}
config.api = gooeto + '/API/';
module.exports = config;



// WEBPACK FOOTER //
// ./src/others/interface.js